// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/react-hot-loader/patch.js");
__webpack_require__("./src/app/hot-loader.js");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?http://0.0.0.0:13001");
var __webpack_exports__ = __webpack_require__("./node_modules/webpack/hot/only-dev-server.js");
